import BaseStore from 'stores/BaseStore';
import { useRootStore } from './useRootStore';

export const useStore = <T extends BaseStore>(name: string) => {
  const rootStore = useRootStore();
  if (!(name in rootStore.stores)) {
    throw new Error(`cannot find ${name} store in rootstore`);
  }
  return rootStore.stores[name] as T;
};
